const config = {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
    callApiBaseUrl: process.env.REACT_APP_CALL_API_BASE_URL,
    inboundCallApiBaseUrl: process.env.REACT_APP_INBOUND_CALL_API_BASE_URL,
    outboundCallApiBaseUrl: process.env.REACT_APP_OUTBOUND_CALL_API_BASE_URL,
  };
export default config;